<template>
    <div class="d-flex" id="avaliacoes-home">
        <div id="avaliacoes-intro">
            <p>Nenhuma avaliação encontrada. Favor verificar o link digitado.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AvaliacoesNotFound',

        props: {},

        components: {},

        data() {
            return {};
        },

        methods: {},
    };
</script>
